import { EmptyViewModelCompactProviderViewView } from "src/formBuilder/structure/elementDecorators/emptyViewModelCompactProviderView/emptyViewModelCompactProviderView-view";

export class Converters{
    getCompactViewForFormBuilderStructureViewDecorators(vm){
        if(vm['getCompactViewForFormBuilderStructureViewDecorators'])
            return vm['getCompactViewForFormBuilderStructureViewDecorators']();
        else
            return new EmptyViewModelCompactProviderViewView();
    }
}
